module.exports = __webpack_public_path__ + "static/ico-cloud-hostingemail-d8d66744d48ddf9a3833dd2a1849543d.svg";